var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('span',{staticClass:"user",class:{'user-deleted': _vm.user ? _vm.user.is_deleted : false}},[_vm._v(" "+_vm._s(_vm.user ? _vm.user.name : '#' + _vm.user.id)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }